/** A save that waits for the changes to stop: `schedule` the latest value,
 *  and it is saved once after `quietMs` without another. `flush` saves a
 *  pending value at once (a chart going away must not lose the last edit);
 *  `cancel` drops it (a reset makes it moot). */
export function debouncedSave<T>(save: (value: T) => void, quietMs: number) {
  let timer: ReturnType<typeof setTimeout> | undefined
  let pending: { value: T } | undefined

  const run = () => {
    timer = undefined
    if (!pending) return
    const { value } = pending
    pending = undefined
    save(value)
  }

  return {
    schedule(value: T) {
      pending = { value }
      if (timer !== undefined) clearTimeout(timer)
      timer = setTimeout(run, quietMs)
    },
    flush() {
      if (timer !== undefined) clearTimeout(timer)
      run()
    },
    cancel() {
      if (timer !== undefined) clearTimeout(timer)
      timer = undefined
      pending = undefined
    },
  }
}
